// Failed password sign-ins per email, counted in a fixed window that starts
// at the first failure. Hitting the limit blocks password sign-in for that
// email, right or wrong, until the window ends.
export const SIGN_IN_MAX_FAILED_ATTEMPTS = 6;
export const SIGN_IN_LOCKOUT_WINDOW_S = 15 * 60;

export const SIGN_IN_LOCKED_ERROR =
  "Too many failed sign-in attempts. Wait 15 minutes, then try again.";
